import React from 'react';
import { getImageBasePath } from 'helpers/env';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';

const AlertsErrorMask = ({
  generalMessage,
  errorList,
  secondaryMessage,
  imgSrc,
  ...props
}) => {
  const title = generalMessage;

  return (
    <Row>
      <FlexContainer className="flex-column items-align-center">
        {imgSrc && (
          <img className="errormask-image" alt="illustration" src={imgSrc} />
        )}
        <div className="errormask-title margB8">
          <Label type="H3" typeHeader={'h2'}>
            {title}
          </Label>
        </div>
        {errorList.length > 0 && (
          <ul className="margB24">
            {errorList.map(error => (
              <li>{error}</li>
            ))}
          </ul>
        )}
        {secondaryMessage && (
          <Label className="margB32">{secondaryMessage} </Label>
        )}
      </FlexContainer>
    </Row>
  );
};

AlertsErrorMask.defaultProps = {
  errorList: [],
  generalMessage: 'There was an unknown problem.',
  imgSrc: `${getImageBasePath()}images/page_error.png`,
};

export default AlertsErrorMask;
